
































































import { genPostReq } from "@/services/checklist.service";

export default  {
  props: ['result_item'], 
  data() {
    return {
      create_progress: false,
      checklist_dialog: {},
      form_data: {},
      itemsState: [
        { text: "-" },
        { text: this.$t('LABEL61'), value: "ok" },
        { text: this.$t('LABEL62'), value: "info" },
        { text: this.$t('LABEL63'), value: "recommendation" },
        { text: this.$t('LABEL64'), value: "warning" },
        { text: this.$t('LABEL65'), value: "alarm" },
        { text: this.$t('LABEL66'), value: "critical" }
      ],
    }
  },
  watch: {
    checklist_dialog: function (val, oldVal) {
      if (!val) {
        this.$emit("dialogClosed", true);

        
      }
    },
  },
  computed: {

  },
  mounted() {

    const lang = "de"
    this.form_data.lang = lang
    this.form_data.stateId = this.result_item.stateId
    this.form_data._id = this.result_item._id
    this.form_data._rev = this.result_item._rev
    this.form_data.componentId = this.result_item.componentId 
    this.form_data.inspectionId = this.result_item.inspectionId 
    this.form_data.taskId = this.result_item.taskId 


    if (this.result_item.reportText && this.result_item.reportText.name ) {
       this.form_data.reportText = this.result_item.reportText.name[lang]
    }
    if (this.result_item.result && this.result_item.result.name ) {
       this.form_data.result = this.result_item.result.name[lang]
    }
    if (this.result_item.recommendation && this.result_item.recommendation.name ) {
       this.form_data.recommendation = this.result_item.recommendation.name[lang]
    }




    console.log(this.result_item) 

    this.$forceUpdate()
  },
  destroyed() {
    //console.log("destroyed")
  },
  methods: {
    closeDialog: function () {
      this.$emit("dialogClosed", true);
    },   
    save: function () {
      console.log(this.form_data)
      this.create_progress = true

      const data = {  
        projectId: this.$store.state.che_projectId, 
        form_data: this.form_data
      }


      genPostReq("inspect-editor", "add-result", data)
        .then(resp => {
          this.create_progress = false;
          this.$store.commit('update_results', resp.data) 
          this.closeDialog()
        })
        .catch(e => {
          //this.$store.dispatch('api_error', e)
        });


    }
     
   
  }
}

